import React, { Component } from "react";
import { Menu, MenuItem, MenuHeader } from "./Menu";
import cx from "classnames";
import "./Select.css";

const SearchToggle = ({ onChange, checked }) => {
  return (
    <label className="Select__SearchToggle" htmlFor="searchToggle">
      <span>Assigned</span>
      <input
        className={`Select__SearchToggleSwitch ${
          checked ? "Select__SearchToggleSwitch--Checked" : ""
        }`}
        type="checkbox"
        checked={checked}
        name="searchToggle"
        onChange={onChange}
      />
      <span>All</span>
    </label>
  );
};

class Select extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      selected: 0,
      value: "",
      filter: "",
    };
  }

  componentWillMount() {
    this.setState({
      value: this.props.defaultValue,
    });
  }

  toggleOpen = () => {
    if (this.props.disabled) return;
    this.setState({
      open: !this.state.open,
      filter: "",
    });
    if (!this.state.open && this.props.onOpen) {
      this.props.onOpen();
    }
  };

  onSetValue = (value) => (e) => {
    if (!this.props.value) {
      this.setState({
        value,
        open: false,
      });
    } else {
      this.setState({
        open: false,
      });
    }
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  onSelectChange = (e) => {
    if (!this.props.value) {
      this.setState({
        value: e.currentTarget.value,
        open: false,
      });
    } else {
      this.setState({
        open: false,
      });
    }
    if (this.props.onChange) {
      this.props.onChange(e.currentTarget.value, e);
    }
  };

  onFilter = (e) => {
    this.setState({
      filter: e.currentTarget.value,
    });
    if (this.props.onFilter) {
      this.props.onFilter(e.currentTarget.value, e);
    }
  };

  onKeyPress = (e) => {
    if (e.key === "Enter") {
      const options = this.filteredOptions();
      const option = options[0];

      if (option) {
        this.onSetValue(option.props.value)();
      }
    }
  };

  filteredOptions = () => {
    const { children } = this.props;
    const { filter } = this.state;

    return React.Children.map(children, (child) => {
      return child;
    }).filter((option) => {
      if (filter && option.type.name === "OptionHeader") {
        return false;
      }
      return (
        !filter ||
        option.props.dontFilter ||
        option.props.children.toLowerCase().indexOf(filter.toLowerCase()) > -1
      );
    });
  };

  render() {
    const {
      children,
      value,
      defaultValue,
      searchable,
      renderValue,
      renderSearch,
      upwards,
      dark,
      style,
      toggleSearch,
      toggleOnChange,
      toggleIsChecked,
      disabled,
      title
    } = this.props;
    const { open, filter } = this.state;
    const options = React.Children.map(children, (child) => {
      return child;
    });

    const selectedIndex = options.findIndex((option, index) => {
      if (!option) {
        return false;
      }
      if (value !== undefined) {
        return option.props.value === value;
      } else if (this.state.value !== undefined) {
        return option.props.value === this.state.value;
      } else {
        return index === 0;
      }
    });

    return (
      <div
        className={cx(
          "Select",
          { "Select--Open": open },
          { "Select--Up": upwards },
          { "Select--Dark": dark }
        )}
        style={style}
      >
        <select
          value={value || this.state.value}
          defaultValue={defaultValue}
          onChange={this.onSelectChange}
          disabled={disabled}
        >
          {options.map((option, index) => (
            <option key={index} value={option.props.value}>
              {option.props.value}
            </option>
          ))}
        </select>
        <div
          data-testid="select-input"
          className="Select__Input"
          onClick={this.toggleOpen}
          disabled={disabled}
          title={title}
        >
          <div className="Select__Value">
            {renderValue ||
              (options[selectedIndex]
                ? options[selectedIndex].props.children
                : "...")}
          </div>
        </div>

        {open && <div className="Select__Overlay" onClick={this.toggleOpen} />}

        {open && (
          <div className={cx("Select__Menu", { "Select__Menu--Up": upwards })}>
            <Menu>
              {open &&
                searchable && (
                  <MenuItem
                    className="Select__Search"
                  >
                    <input
                      onChange={this.onFilter}
                      onKeyPress={this.onKeyPress}
                      placeholder="Filter..."
                      value={filter}
                      autoFocus
                    />
                    {toggleSearch && (
                      <SearchToggle
                        checked={toggleIsChecked}
                        onChange={toggleOnChange}
                      />
                    )}
                  </MenuItem>
                )}
              <div className="Select__MenuItems">
                {this.filteredOptions().map((option, index) =>
                  option.type === OptionHeader ? (
                    <MenuHeader key={index}>
                      <span />
                      {option.props.children}
                      <span />
                    </MenuHeader>
                  ) : (
                    <MenuItem
                      key={index}
                      onClick={this.onSetValue(option.props.value)}
                    >
                      {option}
                    </MenuItem>
                  )
                )}
              </div>
            </Menu>
          </div>
        )}
      </div>
    );
  }
}

const Option = ({ value, children }) => <div>{children}</div>;
const OptionHeader = ({ value, children }) => <div>{children}</div>;

export default Select;
export { Option, OptionHeader };
